import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { MuiButton } from "@ryde/controls";
import { MobilFiltersFooterStyled } from "@ryde/layout";
import { PageHeaderContext, useReportsContext } from "@ryde/redux";
import { TDrawerCloseFunction } from "@ryde/shared";

import { useTableFiltersActionsReports } from "../filters";

interface IMobilFiltersFooterProps {
  onCloseDrawer: TDrawerCloseFunction;
}

export const MobilFiltersFooterReports: FC<IMobilFiltersFooterProps> = ({
  onCloseDrawer,
}) => {
  const { t } = useTranslation();
  const { reportRows } = useReportsContext();

  const rowsCount = useMemo(() => {
    if (!reportRows) {
      return 0;
    }

    return reportRows.length;
  }, [reportRows]);

  const isDisabled = rowsCount < 1;

  const { handleClearFilters } = useTableFiltersActionsReports();
  const { onFiltersClear } = useContext(PageHeaderContext);

  const onClear = async (): Promise<void> => {
    await handleClearFilters();
    onFiltersClear?.();
  };

  return (
    <MobilFiltersFooterStyled>
      <MuiButton
        e2eData="results-report-mobile"
        disabled={isDisabled}
        onClick={onCloseDrawer}
      >
        {t("general.NO_RESULTS_FOUND", { results: rowsCount })}
      </MuiButton>
      <MuiButton
        e2eData="clear-filters-reports-mobile"
        muiVariant="text"
        muiStyle="error"
        startIcon={<PIC.FilterClearSvg />}
        onClick={onClear}
      >
        {t("general.CLEAR")}
      </MuiButton>
    </MobilFiltersFooterStyled>
  );
};
